import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation('common');

  return (
    <section className="py-24 bg-gradient-to-br from-[#14B8A6] via-[#0d9488] to-[#14B8A6]">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center">
          <div className="mb-12 rounded-3xl overflow-hidden w-full h-96">
            <img
              src="https://static.readdy.ai/image/62accdbff4021f687ff0560f8cac3a8c/cc366c599a268bcfc83df361dc1c889a.jpeg"
              alt="Global Trade Partnership"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <h2 className="text-white text-4xl lg:text-5xl font-bold mb-6 leading-tight">
            {t('cta.title1')}<br />
            <span className="font-normal italic">{t('cta.title2')}</span>
          </h2>

          <p className="text-white/90 text-lg mb-12 max-w-2xl mx-auto">
            {t('cta.subtitle')}
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <button className="bg-white text-[#1a2332] px-10 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap">
              {t('cta.button1')}
            </button>
            <button className="bg-white/20 backdrop-blur-sm text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-white/30 transition-all border border-white/30 cursor-pointer whitespace-nowrap">
              {t('cta.button2')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
